import { render, staticRenderFns } from "./form-textarea.vue?vue&type=template&id=57192d22&"
import script from "./form-textarea.vue?vue&type=script&lang=js&"
export * from "./form-textarea.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports